/**
 * The weight fields of the funnel's kidneyProfile (4.39 F6). Pure — no imports,
 * so `npm test` compiles it on its own (tsconfig.test.json).
 *
 * `weight` (kg) is written as before. The `weightUnit` is the unit the buyer
 * picked on the weight step. It used to be forced to 'kg' whenever a weight was
 * given, although the step defaults to and offers lbs. A session persisted
 * before that deploy restores `data` without a `weightUnit`: `undefined` is
 * treated like `null`, and the field is then omitted so the app's region
 * default decides.
 *
 * S1 (2026-10-24): no `dailyProteinLimit` any more. The app reads that legacy
 * field as a limit the USER entered; without it the app works the protein
 * target out from `calculatedLimits.proteinPerKg` × weight, as it does for an
 * account made in the app.
 */

export interface WeightAnswers {
  weightKg?: number | null
  weightUnit?: 'kg' | 'lbs' | null
}

export interface WeightProfileFields {
  weight?: number
  weightUnit?: 'kg' | 'lbs'
}

export function weightProfileFields(data: WeightAnswers): WeightProfileFields {
  const weightKg = data.weightKg || undefined
  if (!weightKg) return {}
  const fields: WeightProfileFields = { weight: weightKg }
  if (data.weightUnit === 'kg' || data.weightUnit === 'lbs') fields.weightUnit = data.weightUnit
  return fields
}
